import { useState } from 'react';
import AuthProvider from './auth/AuthProvider';
import { useAuth } from './auth/AuthContext';
import GardenProvider from './garden/GardenProvider';
import Header from './components/Header/Header';
import Palette from './components/Palette/Palette';
import GardenCanvas from './components/GardenCanvas/GardenCanvas';
import DetailPanel from './components/DetailPanel/DetailPanel';
import AppLayout from './components/Layout/AppLayout';
import Login from './components/Login/Login';
import './App.css';

function AuthGate() {
  const { user, loading } = useAuth();
  const [isPaletteOpen, setIsPaletteOpen] = useState(false);

  if (loading) return <div className="App-loading">Loading…</div>;
  if (!user) return <Login />;

  return (
    <GardenProvider uid={user.uid}>
      <div className="App">
        <Header isMenuOpen={isPaletteOpen} onToggleMenu={() => setIsPaletteOpen((open) => !open)} />
        <AppLayout
          left={<Palette />}
          center={<GardenCanvas />}
          right={<DetailPanel />}
          isPaletteOpen={isPaletteOpen}
          onClosePalette={() => setIsPaletteOpen(false)}
        />
      </div>
    </GardenProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AuthGate />
    </AuthProvider>
  );
}

export default App;
